import { computed, Directive, input } from '@angular/core';
import { TinyColor } from '@ctrl/tinycolor';

/** Stored label colors are solid swatches; always pair them with readable ink. */
@Directive({
  selector: '[bdLabelColor]',
  host: {
    '[style.background-color]': 'background()',
    '[style.color]': 'foreground()',
  },
})
export class BdLabelColorDirective {
  readonly bdLabelColor = input<string | null | undefined>();
  private readonly color = computed(() => {
    const value = this.bdLabelColor();
    const parsed = value ? new TinyColor(value) : null;
    return parsed?.isValid ? parsed : null;
  });
  readonly background = computed(
    () => this.color()?.toHexString() ?? 'var(--p-content-hover-background)',
  );
  readonly foreground = computed(() => {
    const color = this.color();
    if (!color) return 'var(--p-text-color)';
    return color.getLuminance() > 0.179 ? '#000000' : '#ffffff';
  });
}
